import { render, staticRenderFns } from "./OrderNumberEntry.vue?vue&type=template&id=2296dfda&scoped=true"
import script from "./OrderNumberEntry.vue?vue&type=script&lang=js"
export * from "./OrderNumberEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296dfda",
  null
  
)

export default component.exports